// See also variables.less

// Lifted from ComponentLibrary on 2017-07-20

export type MedicationColours = {
    primary: string;
    primaryLight: string;
    primary8: string;
    info: string;
    primaryPale: string;
    tertiary: string;
};

export function overrideMedicationsColours(colours: MedicationColours): void {
    primary = colours.primary;
    primaryLight = colours.primaryLight;
    primary8 = colours.primary8;
    info = colours.info;
    primaryPale = colours.primaryPale;
    tertiary = colours.tertiary;
}

export const useCssColours = 'currentColor';

// Primary colours
export let primary = '#008381';
export let primaryBlue = '#006AD2';
export let primaryLight = '#0070ec';
export let primary8 = '#ebf3fb';
export let info = '#0099ff';
export let primaryPale = '#daebfe';
export let tertiary = '#001e82';
export let primaryGray = '#414141'

// White/Black/Grey
export const heading = '#202020';
export const body = '#707070';
export const iconLight = '#aaa';
export const divider = '#d2d2d2';
export const backgroundAlt = '#f5f5f5';
export const white = '#fff';
export const black = '#000';
export const white50 = 'rgba(255,255,255,0.5)';
export const neutralsGray = '#949494'

export const success = '#ebf8eb';

export const infoGlow = '#EBF7FF';
export const infoGlowBorder = '#0099FF';
export const infoGlowText = '#001E82';

export const successGlow = '#ebf8eb';
export const successGlowBorder = '#00ac00';
export const successGlowText = '#008000';
export const successGlowAccessible = '#007500';

export const errorText = '#c53535';

export const errorGlow = '#FAEFEF';
export const errorGlowBorder = '#C53535';
export const errorGlowText = '#9E043E';

export const warningGlow = '#FEF8ED';
export const warningGlowBorder = '#F5A623';
export const warningGlowText = '#414141';
export const warningGlowAccessible = '#414141';

export let borderGray = '#414141'

// Button variants
export const accentVariant = '#001e82';
export const infoVariant = '#09f';
export const successVariant = '#00ac00';
export const dangerVariant = '#c53535';
export const warningVariant = '#8e5a06';
export const headingVariant = '#202020';
export const lightVariant = '#fff';
export const altVariant = '#f5f5f5';
export const altVariantText = '#757575'

// Other colours
export const red = '#d0011b';
export const orange = '#f5a623';
export const green = '#00ac00';
export const babyBlue = '#6CA1E3';
export const warningIcon = "#B7591A";
export const errorIcon = "#D93923";

// Avatar colours
export const avatarColours = [
    '#E91E63',
    '#9C26B0',
    '#4051B5',
    '#2196F3',
    '#00BCD4',
    '#4BAF50',
    '#8BC34A',
    '#FFC10A',
    '#FF9802',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B'
];

// medication card
export const medicationStopped = '#aaa';
export const medicationExpired = '#c53535';
export const medicationAboutToExpireIcon = '#f5a623';
export const medicationAboutToExpireText = '#925d07';
export const expiredRowIcon = '#c53535';
export const warningRowIcon = '#f5a623';
